<template>
  <div>
    <v-layout>
      <v-flex xs12 sm12 md12 lg6 offset-lg3>
        <v-container fluid>
          <v-form v-model="valid">
            <v-stepper v-model="step">
              <v-stepper-header>
                <v-stepper-step step="1" :complete="stepperCompleted1">{{ $t('newSchool.STEP_BASIC') }}</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2" :complete="step > 2">{{ $t('newSchool.STEP_CONTACT') }}</v-stepper-step>
              </v-stepper-header>
              <div style="position: relative">
                <v-stepper-content step="1">
                  <v-layout wrap>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('school.NAME')"
                        v-model="newSchool.name"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('school.FACULTY')"
                        v-model="newSchool.faculty"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <language-text-field v-model="newSchool.language"></language-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-btn flat disabled>{{ $t('forms.BACK') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn primary @click.native="step = 2" :disabled="!stepperCompleted1">{{ $t('forms.CONTINUE') }}</v-btn>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-layout wrap>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('school.TOWN')"
                        v-model="newSchool.town"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8 offset-xs2>
                      <v-text-field
                        :label="$t('school.COUNTRY')"
                        v-model="newSchool.country"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-layout>
                      <v-btn flat @click.native="step = 1">{{ $t('forms.BACK') }}</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn primary @click.native="submit" :disabled="!stepperCompleted2">{{ $t('newSchool.SAVE_SCHOOL') }}</v-btn>
                    </v-layout>
                  </v-layout>
                </v-stepper-content>
              </div>
            </v-stepper>
          </v-form>
        </v-container>
      </v-flex>
    </v-layout>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Schools' })"><v-icon>arrow_back</v-icon></v-btn>
  </div>
</template>

<script>
import LanguageTextField from '../common/LanguageTextField'
import { SchoolResource } from '../../api/school'
import EvaloeEmailField from '../common/evaloeEmailField'
export default {
  components: {
    EvaloeEmailField,
    LanguageTextField
  },
  name: 'newSchool',
  data () {
    return {
      newSchool: {
        name: '',
        faculty: '',
        language: '',
        town: '',
        country: ''
      },
      step: 1
    }
  },
  computed: {
    stepperCompleted1 () {
      return (
        this.newSchool.name !== '' &&
        this.newSchool.faculty !== '' &&
        this.newSchool.language !== ''
      )
    },
    stepperCompleted2 () {
      return (
        this.stepperCompleted1 &&
        this.newSchool.town !== '' &&
        this.newSchool.country !== ''
      )
    }
  },
  methods: {
    submit () {
      SchoolResource().saveSchool(this.newSchool).then(response => {
        this.$router.push({ name: 'Schools' })
      }, response => {
        console.log(response)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schools/newSchool.vue